import { render } from "./CustomersBaseFilter.vue?vue&type=template&id=08814ffe&scoped=true"
import script from "./CustomersBaseFilter.vue?vue&type=script&lang=js"
export * from "./CustomersBaseFilter.vue?vue&type=script&lang=js"

import "./CustomersBaseFilter.vue?vue&type=style&index=0&id=08814ffe&lang=scss&scoped=true"
import "./CustomersBaseFilter.vue?vue&type=style&index=1&id=08814ffe&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08814ffe"]])

export default __exports__